import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { OrderHistory } from '../../../models/order-history.model';
import { convertOrderState } from '../../../shared/utils';
import {
  COMPLETE_STATE,
  PENDING_STATE,
  PRODUCTION_STATE,
  QUOTE_STATE,
  VOID_STATE,
} from '../../../constants/order-states';
import { Router } from '@angular/router';

@Component({
  selector: 'app-brief-order-history-info',
  templateUrl: './brief-order-history-info.component.html',
  styleUrls: ['./brief-order-history-info.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BriefOrderHistoryInfoComponent implements OnInit {
  @Input() order: OrderHistory;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  get status(): string {
    return convertOrderState(this.order.state);
  }

  get statusColorClass() {
    if (this.order.state === PENDING_STATE) {
      return 'color--warning';
    }
    if (this.order.state === COMPLETE_STATE) {
      return 'color--green';
    }
    if (this.order.state === VOID_STATE) {
      return 'color--alert';
    }

    return '';
  }

  navigateToOrder() {
    this.router.navigate([`/account/orders/${this.order.id}`]);
  }
}
